import Button from "./button.js";

export default Button;
